import useWindowSize from './use-window-size';

const NW_TABLET_BREAKPOINT = 768;
const NW_DESKTOP_BREAKPOINT = 1280;

type isMobileResults = {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
};

/**
 * Hook that returns if current window should be using mobile layout
 * Notice that in SSR this will return false for all
 */
const useIsMobile = (): isMobileResults => {
  const { width } = useWindowSize();

  if (typeof window === 'undefined') {
    return {
      isMobile: false,
      isTablet: false,
      isDesktop: false,
    };
  }

  return {
    isMobile: width < NW_TABLET_BREAKPOINT,
    isTablet: width >= NW_TABLET_BREAKPOINT && width <= NW_DESKTOP_BREAKPOINT, // we created this only for a few specific use cases, please avoid using other breakpoints that are not isMobile if is not necessary
    isDesktop: width > NW_DESKTOP_BREAKPOINT,
  };
};

export default useIsMobile;
